export default __webpack_public_path__ + "img/icon_we_use_mssgme_ru.svg";